<template>
    <div class="patient-swiper">
        <div class="arrow prev" :class="isFirstPatient ? 'disable' : ''" @click="$emit('before')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.0949 14C22.1994 14 23.0949 13.1046 23.0949 12C23.0949 10.8954 22.1994 10 21.0949 10V14ZM2.83398 12L1.45017 10.556C1.05655 10.9332 0.833984 11.4548 0.833984 12C0.833984 12.5452 1.05655 13.0668 1.45017 13.444L2.83398 12ZM14.6526 3.44398C15.4501 2.67972 15.477 1.41368 14.7127 0.616189C13.9485 -0.181297 12.6824 -0.208234 11.885 0.556024L14.6526 3.44398ZM11.885 23.444C12.6824 24.2082 13.9485 24.1813 14.7127 23.3838C15.477 22.5863 15.4501 21.3203 14.6526 20.556L11.885 23.444ZM21.0949 10H2.83398V14H21.0949V10ZM4.2178 13.444L14.6526 3.44398L11.885 0.556024L1.45017 10.556L4.2178 13.444ZM1.45017 13.444L11.885 23.444L14.6526 20.556L4.2178 10.556L1.45017 13.444Z" fill="#575A5D"/>
            </svg>
        </div>
        <div class="arrow next" :class="isLastPatient ? 'disable' : ''" @click="$emit('next')">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.9071 10C1.80253 10 0.907098 10.8954 0.907098 12C0.907098 13.1046 1.80253 14 2.9071 14L2.9071 10ZM21.168 12L22.5518 13.444C22.9454 13.0668 23.168 12.5452 23.168 12C23.168 11.4548 22.9454 10.9332 22.5518 10.556L21.168 12ZM9.34938 20.556C8.55189 21.3203 8.52495 22.5863 9.28921 23.3838C10.0535 24.1813 11.3195 24.2082 12.117 23.444L9.34938 20.556ZM12.117 0.556025C11.3195 -0.208232 10.0535 -0.181296 9.28921 0.616191C8.52495 1.41368 8.55189 2.67972 9.34937 3.44398L12.117 0.556025ZM2.9071 14L21.168 14L21.168 10L2.9071 10L2.9071 14ZM19.7842 10.556L9.34938 20.556L12.117 23.444L22.5518 13.444L19.7842 10.556ZM22.5518 10.556L12.117 0.556025L9.34937 3.44398L19.7842 13.444L22.5518 10.556Z" fill="#575A5D"/>
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    props : ['isFirstPatient', 'isLastPatient']
}
</script>

<style lang="scss" scoped>
.patient-swiper{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    position: fixed;
    bottom: 100px;
    z-index: 10;

    .arrow{
        background: #C8DBE1;
        border-radius: 50%;
        width: 4.167vw;
        height: 4.167vw;

        display: flex;
        align-items: center;
        justify-content: center;

        position: absolute;

        cursor: pointer;

        svg{
            height: 1.042vw;
            width: auto;
        }
    }

    .prev{
        left: 2vw;
    }

    .next{
        right: 2vw;
    }

    .disable{
        cursor: not-allowed;
        opacity: 0;
    }
}
</style>